import React, { useEffect } from "react";
import { MdOutlineArrowBackIos } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchPayments } from "../../redux/slices/paymentSlice"; 
import TableComponent from "../../components/common/TableComponent";
import { FiDownload } from "react-icons/fi";

export default function Payment() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const payments = useSelector((state) => state.payment.items);
  const status = useSelector((state) => state.payment.status);

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchPayments());
    }
  }, [dispatch, status]);

  const statusClasses = {
    Completed: "bg-green-100 text-green-500",
    Failed: "bg-red-100 text-red-500",
    Pending: "bg-yellow-100 text-yellow-600",
    Default: "bg-gray-100 text-gray-600",
  };

  const columns = [
    { key: "id", label: "Transaction ID" },
    { key: "type", label: "Type" },
    { key: "user", label: "User" },
    { key: "amount", label: "Amount" },
    { key: "date", label: "Date" },
    {
      key: "status",
      label: "Status",
      render: (val) => (
        <span
          className={`rounded-md px-3 py-1 text-xs font-semibold ${
            statusClasses[val] || statusClasses.Default
          }`}
        >
          {val}
        </span>
      ),
    },
  ];

  const renderCell = (key, value) => {
    if (key === "status") {
      return (
        <span
          className={`rounded-md px-3 py-1 text-xs font-semibold ${
            statusClasses[value] || statusClasses.Default
          }`}
        >
          {value}
        </span>
      );
    }
    return value;
  };

  const handleRowClick = (row) => {
    navigate(`/swift-app/admin/payments/${row.id}`);
  };

  // Navigate to ExportPage
  // const handleExportClick = () => {
  //   navigate(`/swift-app/admin/export?tab=Payments`);
  // };

  return (
    <div className="px-3 sm:px-6 md:px-8 lg:px-12 pt-6 md:pt-8 font-inter min-h-screen bg-white">
      {/* ✅ Header */}
      <div className="flex flex-col gap-4">
        {/* Top Row — Back button + Title + Export */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate(-1)}
              aria-label="Go Back"
              className="p-2 md:p-3 text-lg md:text-xl text-gray-800 hover:text-blue-600"
            >
              <MdOutlineArrowBackIos />
            </button>
            <h1 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-900">
              Payment
            </h1>
          </div>

          {/* ✅ Responsive Export button */}
             {/* Icon always visible */}
          {/* <button
            onClick={handleExportClick}
            className="flex items-center justify-center gap-2 bg-blue-500 text-white font-medium px-3 sm:px-4 md:px-5 py-2 rounded-lg shadow hover:bg-blue-600 transition"
          >
         
            <FiDownload className="w-5 h-5" />
            <span className="hidden lg:inline">Export</span>
          </button> */}
        </div>

        {/* Subtitle */}
        <p className="text-gray-600 text-sm sm:text-base ml-10 md:ml-14">
          Manage payment transactions
        </p>
      </div>

      {/* ✅ Table */}
      <div className="mt-8 md:mt-10 overflow-x-auto">
        {status === "loading" ? (
          <div className="text-center text-gray-500 py-10 text-sm md:text-base">
            Loading...
          </div>
        ) : (
          <TableComponent
            columns={columns}
            data={payments}
            renderCell={renderCell}
            onRowClick={handleRowClick}
          />
        )}
      </div>
    </div>
  );
}
